/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MachineRentalTypeCreateModel
 */
export interface MachineRentalTypeCreateModel {
    /**
     * 
     * @type {number}
     * @memberof MachineRentalTypeCreateModel
     */
    price?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineRentalTypeCreateModel
     */
    rentalTypeId?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineRentalTypeCreateModel
     */
    currencyId?: number;
}

export function MachineRentalTypeCreateModelFromJSON(json: any): MachineRentalTypeCreateModel {
    return MachineRentalTypeCreateModelFromJSONTyped(json, false);
}

export function MachineRentalTypeCreateModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): MachineRentalTypeCreateModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'price': !exists(json, 'price') ? undefined : json['price'],
        'rentalTypeId': !exists(json, 'rentalTypeId') ? undefined : json['rentalTypeId'],
        'currencyId': !exists(json, 'currencyId') ? undefined : json['currencyId'],
    };
}

export function MachineRentalTypeCreateModelToJSON(value?: MachineRentalTypeCreateModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'price': value.price,
        'rentalTypeId': value.rentalTypeId,
        'currencyId': value.currencyId,
    };
}

